import el from "@cypherpotato/el";
import page from "page";
import { api } from "../../../api";
import { Button, ButtonRow, DangerButton } from "../../../components/button";
import { Card, CardContent, CardHeader } from "../../../components/card";
import { CommandBar } from "../../../components/command-bar";
import { Dashboard, DashboardTitle } from "../../../components/dashboard";
import { DateTimeLabel } from "../../../components/datetime-label";
import { Dropdown, DropdownDivider, DropdownItem } from "../../../components/dropdown";
import { TextInput } from "../../../components/form";
import { Icon } from "../../../components/icon";
import { Section } from "../../../components/layout";
import { Link } from "../../../components/link";
import { DefaultRow, Table, TableActionCell, TableBody, TableCell, TableHeader, TableHeaderCell, TableRow } from "../../../components/table";
import { CopiableText, MutedText, Paragraph } from "../../../components/text";
import { showFlyout } from "../../../ui/flyout";
import { formatNumber } from "../../../ui/format";
import { runOperation } from "../../../ui/operation";
import { throttledCall } from "../../../ui/throttle";
import { ellipsis } from "../../../util";
import { copyToClipboard } from "../../../ui/clipboard";

export default function (ctx) {

    const chatClientId = ctx.params.id;
    const chatSessions = el.state.create(null);

    var filter = "";

    async function refreshTable() {
        const response = await api.getJson(`/api/v1/web-chat-client/${chatClientId}/sessions?filter=${encodeURIComponent(filter)}`);
        chatSessions.value = response.data;
    }

    refreshTable();

    return Dashboard(
        Section(
            Link(el.fragment(Icon("arrow-left-line"), "Return back"), null, {
                onClick() {
                    history.go(-1);
                    page();
                }
            })
        ),
        DashboardTitle(
            "Chat sessions",
            "Here you can view and manage your chat sessions."
        ),
        Section(
            CommandBar(
                Button(Icon("add-line"), "New session", {
                    onClick() {
                        page(`/dashboard/chat-clients/${chatClientId}/sessions/create`);
                    }
                }),
                Button(Icon("refresh-line"), "Refresh", {
                    onClick() {
                        refreshTable();
                    }
                })
            )
        ),
        Section(
            CommandBar(
                TextInput(null, "Find sessions...", {
                    onInput(event) {
                        throttledCall(() => {
                            filter = event.target.value;
                            refreshTable();
                        }, 500);
                    }
                })
            )
        ),
        Section(
            Card(
                CardHeader(
                    "Chat sessions"
                ),
                CardContent(
                    Table(
                        {
                            pagination: {
                                perPage: 80
                            }
                        },
                        TableHeader(
                            TableHeaderCell("Session key"),
                            TableHeaderCell("Tag/User"),
                            TableHeaderCell("Diagnostics"),
                            TableHeaderCell("Created at"),
                            TableHeaderCell("Last activity"),
                            TableHeaderCell("Context"),
                            TableHeaderCell("Actions")
                        ),
                        el.state.listening([chatSessions], () =>
                            TableBody(
                                chatSessions.value?.map(session =>
                                    TableRow(
                                        TableCell(
                                            CopiableText(ellipsis(session.sessionKey, 15), session.sessionKey)
                                        ),
                                        TableCell(
                                            session.tagName && CopiableText(ellipsis(session.tagName, 15), session.tagName) || MutedText("None")
                                        ),
                                        TableCell(
                                            el("div",
                                                formatNumber(session.tokenCount), " tokens"
                                            ),
                                            el("small",
                                                MutedText(
                                                    formatNumber(session.messageCount), " messages"
                                                )
                                            )
                                        ),
                                        TableCell(
                                            DateTimeLabel(session.createdAt)
                                        ),
                                        TableCell(
                                            session.lastMessage && DateTimeLabel(session.lastMessage) || MutedText("Never")
                                        ),
                                        TableCell(
                                            ellipsis(session.contextPreview, 40)?.nullWhenEmpty() || MutedText("None")
                                        ),
                                        TableActionCell(
                                            ButtonRow(
                                                Button(Icon("chat-forward-line"), {
                                                    onClick() {
                                                        window.open(`/chat/${session.sessionKey}`, "_blank");
                                                    }
                                                }),
                                                Dropdown(null,
                                                    DropdownItem("Copy link", Icon("file-copy-line"), {
                                                        onClick() {
                                                            copyToClipboard(`${window.location.origin}/chat/${session.sessionKey}`)
                                                        }
                                                    }),
                                                    DropdownDivider(),
                                                    DropdownItem("Export conversation", Icon("upload-2-line"), {
                                                        onClick() {
                                                            window.open(window.env.apiEndpoint + `/api/v1/public/chat-clients/${session.sessionKey}/transcript.json`, '_blank');
                                                        }
                                                    }),
                                                    DropdownDivider(),
                                                    DropdownItem("Clear conversation", Icon("delete-back-line"), {
                                                        onClick() {
                                                            showFlyout(
                                                                Paragraph("This will clear the user conversation, but not the session itself. Do you want to continue?"),
                                                                DangerButton("Yes, clear the chat session", {
                                                                    onClick() {
                                                                        runOperation("Clearing session...", async () => {
                                                                            await api.postJson(`/api/v1/public/chat-clients/${session.sessionKey}/reset-state`);
                                                                            refreshTable();
                                                                        });
                                                                    }
                                                                })
                                                            )
                                                        }
                                                    }),
                                                    DropdownItem("Delete", Icon("delete-bin-7-line"), {
                                                        onClick() {
                                                            showFlyout(
                                                                Paragraph("This will delete the entire session conversation. Do you want to continue?"),
                                                                DangerButton("Yes, delete the session", {
                                                                    onClick() {
                                                                        runOperation("Deleting session...", async () => {
                                                                            await api.deleteJson(`/api/v1/web-chat-client/${chatClientId}/sessions/${session.id}`);
                                                                            refreshTable();
                                                                        });
                                                                    }
                                                                })
                                                            )
                                                        }
                                                    })
                                                )
                                            )
                                        )
                                    )
                                )?.nullWhenEmpty() || DefaultRow("No chat sessions found."),
                                {
                                    mount() {
                                        this.closest('table').refreshPagination();
                                    }
                                }
                            )
                        )
                    )
                )
            )
        )
    )
}
